const DefaultLayout = () => import("@/layouts/default/DefaultLayout.vue");

export const menuV2Router = [
  {
    path: "/menus-v2",
    component: DefaultLayout,
    children: [
      {
        path: "",
        name: "menu-v2",
        component: () => import("../pages/menu-v2/MenuList.vue"),
        meta: {
          text: "$vuetify.layout.navigationSidebar.menuItems",
          parent: {
            name: "$vuetify.layout.navigationSidebar.menu",
            path: "/menus-v2",
            disabled: false,
          },
        },
      },
      {
        path: "/menus-v2/detail/:id",
        name: "menu-v2-detail",
        component: () => import("../pages/menu-v2/detail-menu/DetailMenu.vue"),
        meta: {
          text: "$vuetify.layout.navigationSidebar.menuDetails",
          parent: {
            name: "$vuetify.layout.navigationSidebar.menu",
            disabled: false,
            path: "/menus-v2",
            exact: true,
          },
        },
      },
      {
        path: "/menus-v2/menu-detail/:id",
        name: "menu-v2-mobile-detail",
        component: () => import("../pages/menu-v2/detail-menu/MenuCardDetailPage.vue"),
        meta: {
          text: "$vuetify.layout.navigationSidebar.menuDetails",
          parent: {
            name: "$vuetify.layout.navigationSidebar.menu",
            disabled: false,
            path: "/menus-v2",
            exact: true,
          },
        },
      },
    ],
  },
];
